var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-container",style:({ backgroundColor: _vm.color, height: _vm.actualSize, width: _vm.actualSize, minWidth: _vm.actualSize, minHeight: _vm.actualSize})})}
var staticRenderFns = []

export { render, staticRenderFns }